<template>
  <h1>{{ $t('menu.pim.subpages.productsPricing.header')}} ({{ this.hotSettings.data.length }})</h1>
  <div class="pb-4">
    <button class="appButton mt-2" @click="this.$router.push('/pim')">{{ $t('menu.pim.subpages.productsPricing.back')
      }}</button>
    <button class="appButton mt-2" @click="refresh()">{{ $t('menu.pim.subpages.productsPricing.refresh')
      }}</button>
  </div>
  <div
    class="mb-4 rounded-md"
    :style="missingPriceCount === 0
      ? 'background: #142218; border: 1px solid rgba(74,222,128,0.3);'
      : 'background: #2a2410; border: 1px solid rgba(250,204,21,0.3);'"
  >
    <div
      class="p-3 flex items-center cursor-pointer select-none"
      @click="missingPriceExpanded = !missingPriceExpanded"
    >
      <span class="mr-2">{{ missingPriceExpanded ? '▼' : '▶' }}</span>
      <span>{{ $t('menu.pim.subpages.productsPricing.missingPrice') }}:</span>
      <span class="ml-2 font-semibold" :class="missingPriceCount === 0 ? 'text-green-400' : 'text-yellow-400'">
        {{ missingPriceCount }}
      </span>
    </div>
    <div v-if="missingPriceExpanded && missingPriceCount > 0" class="px-3 pb-3">
      <table class="w-full text-sm">
        <thead>
          <tr class="text-left" style="border-bottom: 1px solid rgba(255,255,255,0.1);">
            <th class="py-2 pr-4">SKU</th>
            <th class="py-2 pr-4">Title</th>
            <th class="py-2 pr-4">Status</th>
            <th class="py-2 pr-4">Inventory</th>
            <th class="py-2 pr-4">Price (eur)</th>
            <th class="py-2 pr-4">Compare At Price (eur)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in missingPriceRows" :key="row[0]" style="border-bottom: 1px solid rgba(255,255,255,0.05);">
            <td class="py-1 pr-4">{{ row[1] }}</td>
            <td class="py-1 pr-4">{{ row[2] }}</td>
            <td class="py-1 pr-4">{{ row[3] }}</td>
            <td class="py-1 pr-4">{{ row[4] }}</td>
            <td class="py-1 pr-4">{{ row[5] }}</td>
            <td class="py-1 pr-4">{{ row[6] }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="flex">
    <div class="w-full">
      <hot-table :settings="hotSettings"></hot-table>
    </div>
  </div>

</template>

<script>
import { useSettings } from '@/store/user'
import mixins from '@/components/mixins';
import { HotTable } from '@handsontable/vue3';
import { registerAllModules } from 'handsontable/registry';
import 'handsontable/dist/handsontable.full.css';

// register Handsontable's modules
registerAllModules();

export default {
    mixins: [mixins],
    setup() {
        const user = useSettings();

        return { user }
    },
    created() {
      this.hotSettings.data = this.user.pim.products.map(product => {
        return [product.id, product.sku, product.title, product.status, product.inventoryQuantity, product.price, product.compare_at_price, product.internal_comment];
      });
    },
    components: {
      HotTable,
    },
    computed: {
      missingPriceRows() {
        return this.hotSettings.data.filter(row => {
          const status = (row[3] || '').toString().toUpperCase();
          const price = row[5];
          const priceNum = parseFloat(price);
          const priceMissing = price === null || price === undefined || price === '' || priceNum === 0 || isNaN(priceNum);
          return status === 'ACTIVE' && priceMissing;
        });
      },
      missingPriceCount() {
        return this.missingPriceRows.length;
      }
    },
    data() {
      return {
        missingPriceExpanded: false,
        hotSettings: {
          data: [],
          height: 'auto',
          filters: false,
          dropdownMenu: false,
          // hiddenColumns: {
          //   columns: [0],
          //   indicators: false
          // },
          manualRowMove: false,
          autoWrapRow: true,
          autoWrapCol: true,
          fillHandle: true,
          rowHeaders: true,
          colHeaders: ['ID', 'SKU', 'Title', 'Status', 'Inventory', 'Price (eur)', 'Compare At Price (eur)','Comment'],
          columns: [
            { data: 0, name: 'id', type: 'numeric', editor: false},
            { data: 1, name: 'sku', type: 'text', editor: false},
            { data: 2, name: 'title', type: 'text', editor: false},
            { data: 3, name: 'status', type: 'text', editor: false},
            { data: 4, name: 'inventory', type: 'text', editor: false},
            { data: 5, name: 'price', type: 'text', editor: false},
            { data: 6, name: 'compare_at_price', type: 'text'},
            { data: 7, name: 'internal_comment', namespace: 'custom', field_type: 'single_line_text_field', type: 'text'},
          ],
          // licenseKey: '53013-4578b-9e935-c450e-92257',
          licenseKey: 'non-commercial-and-evaluation',
          afterChange: (changes) => {
            changes?.forEach(([row, prop, oldValue, newValue]) => {
              
              // extract the Shopify ID from the product ID
              const match = this.user.pim.products[row].id.match(/gid:\/\/shopify\/Product\/(\d+)/);
              const Shopify_id = match ? match[1] : null;

              const field = this.hotSettings.columns[prop].name;
              const field_type = this.hotSettings.columns[prop].field_type || 'single_line_text_field';
              const namespace = this.hotSettings.columns[prop].namespace || 'custom';

              const obj = {
                productId: Shopify_id,
                metafield: field,
                value: newValue,
                type: field_type,
                namespace: namespace
              };

              console.log('Updating product pricing:', obj);
              
              this.user.updateProductPim(obj);
            });
          }
        },
      };
    },
    methods: {
       refresh() {
        this.hotSettings.data = [];
        this.user.getProductsPim().then(() => {
          this.hotSettings.data = this.user.pim.products.map(product => {
            return [product.id, product.sku, product.title, product.status, product.inventoryQuantity, product.price, product.compare_at_price, product.internal_comment];
          });
        });
      }
    }
};

</script>